import styled, { css } from 'styled-components'
import { TableComponents, Pill, FlatButton } from '@sketch/components'
import { ReactComponent as Lock } from '@sketch/icons/lock-closed-17'
import { ReactComponent as Link } from '@sketch/icons/markdown-link-share-17'
import { ReactComponent as Sliders } from '@sketch/icons/sliders-3-17'
import { ReactComponent as Arrow } from '@sketch/icons/arrow-right-circle-semifilled-17'

export const TableCell = styled(TableComponents.TableCell)`
  vertical-align: top;
  padding: 20px 8px 4px 20px;
`

export const TableRow = styled(TableComponents.TableRow)`
  vertical-align: top;

  & > td:nth-child(1) {
    width: 260px;
  }
`

export const DocumentPreviewsLayoutWrapper = styled.div`
  margin: 0 0 16px;
  position: relative;

  ${TableComponents.Table} {
    min-width: 640px;
  }
`

export const DocumentThumbnail = styled.div(
  ({ theme }) => css`
    width: 32px;
    height: 32px;
    margin-right: 12px;
    border: 1px solid ${theme.colors.border.A};
    border-radius: ${theme.radii.medium};
  `
)

export const DocumentName = styled.span(
  ({ theme }) => css`
    color: ${theme.colors.foreground.secondary.A};
    font-weight: ${theme.fontWeights.medium};
    font-size: ${theme.fontSizes.E};
  `
)

const iconStyles = css`
  width: 17px;
  height: 17px;
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
`

export const ArrowIcon = styled(Arrow)`
  ${iconStyles};
`

export const SlidersIcon = styled(Sliders)`
  ${iconStyles};
  margin-right: 24px;
`

export const LinkIcon = styled(Link)`
  ${iconStyles};
  margin-right: 24px;
`

export const LockIcon = styled(Lock)`
  ${iconStyles};
`

export const ActionButton = styled(FlatButton)`
  ${iconStyles};
`

export const PreviewOverview = styled.div`
  display: flex;
  align-items: center;
  column-gap: 4px;
  ${Pill} {
    margin-left: 4px;
  }
`
